import { ListKeyManagerOption } from '@angular/cdk/a11y';
import { Component, OnInit, Input, HostBinding, ElementRef } from '@angular/core';
import { AutoCompleteListItemInterface } from '../../interfaces/auto-complete.interfaces';

@Component({
    selector: 'da-acs-list-item-v3',
    templateUrl: './acs-list-item-v3.component.html',
    styleUrls: ['./acs-list-item-v3.component.scss']
})
export class AcsListItemV3Component implements OnInit, ListKeyManagerOption {
    @Input() item: AutoCompleteListItemInterface;

    @HostBinding('class.active') get isActive() {
        return this._isActive;
    }

    get nativeElement(): HTMLElement {
        return this._elementRef.nativeElement;
    }

    private _isActive = false;

    constructor(private _elementRef: ElementRef) {}

    ngOnInit() {}

    getLabel(): string {
        return this.item.label;
    }

    getValue(): string | number {
        return this.item.value !== undefined ? this.item.value : null;
    }

    setActiveStyles() {
        this._isActive = true;
    }

    setInactiveStyles() {
        this._isActive = false;
    }
}
